// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FavoriteButton__favorite___U3z1z {
    width: var(--space-2xl);
    height: var(--space-2xl);
    padding: 0.4rem;

    color: gold;

    border-radius: var(--control-radius);

    &:hover {
        background: var(--color-control-bg-clear-hover);
    }
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Main/ProjectsView/FavoriteButton/FavoriteButton.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,eAAe;;IAEf,WAAW;;IAEX,oCAAoC;;IAEpC;QACI,+CAA+C;IACnD;AACJ","sourcesContent":[".favorite {\n    width: var(--space-2xl);\n    height: var(--space-2xl);\n    padding: 0.4rem;\n\n    color: gold;\n\n    border-radius: var(--control-radius);\n\n    &:hover {\n        background: var(--color-control-bg-clear-hover);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"favorite": `FavoriteButton__favorite___U3z1z`
};
export default ___CSS_LOADER_EXPORT___;
